// extracted by mini-css-extract-plugin
export default {"content":"_babee0a2","children":"_22007918"};